
import utils from '@/vue-utils'
import FacetTagMenuParentItem from '@/components/facet/FacetTagMenuParentItem.vue'
import FacetTagMenuItem from '@/components/facet/FacetTagMenuItem.vue'
import tracking from '@/helpers/tracking'
import store from '@/components/facet/store'


const $root = document.querySelector('.js-facet-menu')
const $overlay = $root?.querySelector('.js-facet-tag-menu__overlay')

const mountTags = ($accordionItem) => {
  utils.mountChildComponents({
    FacetTagMenuParentItem,
    FacetTagMenuItem
  }, null, $accordionItem)
}

const initOverlayClick = () => {
  $overlay.addEventListener('click', (e) => {
    e.preventDefault()
    store.dispatch('setAllFiltersVisibility', { value: false })
  })
}

const initMainAccordion = () => {
  const $accordionTitles = Array.from($root.querySelectorAll('.js-accordion-title')).map((node) => ({
    node,
    initialized: false
  }))
  const toggleAccordionContent = (item) => {
    const openedClassName = 'is-opened'
    if (item.node.classList.contains(openedClassName)) {
      item.node.classList.remove(openedClassName)
      item.node.nextElementSibling.classList.remove(openedClassName)
    } else {
      $accordionTitles.forEach(({ node }) => {
        node.classList.remove(openedClassName)
        node.nextElementSibling.classList.remove(openedClassName)
      })
      const filterCategory = item.node.innerText.replace(item.node.children[0]?.innerText, '').trim()

      const { currentTagsAndTerms: currentFilters } = store.getters
      tracking.expandFilterMenu({
        filterCategory,
        currentFilters,
        placement: 'filter menu'
      })

      if (!item.initialized) {
        item.initialized = true
        mountTags(item.node.parentNode)
        requestAnimationFrame(() => {
          item.node.classList.add(openedClassName)
          item.node.nextElementSibling.classList.add(openedClassName)
          item.node.scrollIntoViewIfNeeded()
        })
      } else {
        item.node.classList.add(openedClassName)
        item.node.nextElementSibling.classList.add(openedClassName)
        item.node.scrollIntoViewIfNeeded()
      }
    }
  }

  $accordionTitles.forEach((item) => {
    item.node.addEventListener('click', (e) => {
      e.preventDefault()
      toggleAccordionContent(item)
    })
  })
}


export default {
  initMainAccordion,
  initOverlayClick
}
